import BaseEntity from '@/entities/BaseEntity';
import ProductSet from '@/entities/ProductSet';

export default class ProductCatalogue extends BaseEntity {
  id = null;
  platform = null;
  external_id = null;
  name = '';
  product_sets = [];
  deleted_at = null;

  _entityArrayFields = {
    product_sets: ProductSet,
  };

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }
}
